import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
export const useOnceVisible = (callback, t0) => {
  const $ = _c(8);
  const threshold = t0 === undefined ? 0.1 : t0;
  const ref = useRef(null);
  const rafRef = useRef(null);
  const callbackRef = useRef(callback);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (rafRef.current !== null) {
        cancelAnimationFrame(rafRef.current);
        rafRef.current = null;
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const cancel = t1;
  let t2;
  let t3;
  if ($[1] !== callback) {
    t2 = () => {
      callbackRef.current = callback;
    };
    t3 = [callback];
    $[1] = callback;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[4] !== threshold) {
    t4 = () => {
      const element = ref.current;
      if (!element) {
        return;
      }
      const observer = new IntersectionObserver(t6 => {
        const [entry] = t6;
        if (entry.isIntersecting) {
          const outerRaf = requestAnimationFrame(() => {
            rafRef.current = requestAnimationFrame(() => {
              callbackRef.current();
            });
          });
          rafRef.current = outerRaf;
          observer.disconnect();
        }
      }, {
        threshold
      });
      observer.observe(element);
      return () => {
        observer.disconnect();
        cancel();
      };
    };
    t5 = [threshold];
    $[4] = threshold;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      ref,
      cancel
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};